<template>
  <div class="content content-shareto">
    <div class="center-bar">
      <div class="content-main">
        <div class="content-navTab">
          <div class="nav-tools"></div>
          <k-form inline>
            <k-form-group
              label-suffix="firstName"
              label-for="firstName"
              label-align-md="right"
              label-cols-md="4"
              content-cols-lg="6"
              content-cols-md="7"
            >
              <k-form-input name="firstName" v-model="queryGrid.firstName" />
            </k-form-group>
            <k-form-group
              label-suffix="lastName"
              label-for="lastName"
              label-align-md="right"
              label-cols-md="4"
              content-cols-lg="6"
              content-cols-md="7"
              class="ml-3"
            >
              <k-form-input name="lastName" v-model="queryGrid.lastName" />
            </k-form-group>
            <k-button class="ml-4" type="button" @click="refreshGrid"
              >search</k-button
            >
          </k-form>
        </div>
        <div class="content-party">
          <konn-grid
            :has-action="false"
            ref="selectableTable"
            :dataSource="dataSource"
            :getCondition="getCondition"
            @total-changed="onTotalChanged"
            :fields="fields"
            grid-sort-by="firstName"
            class="stickyTable"
          >
          </konn-grid>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getUsers } from "../api/searchArea";
export default {
  components: {},
  props: {
    sharedUserId: {
      type: String,
      default: null,
    },
    searchId: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      fields: [
        {
          key: "firstName",
          label: "modal.shareTo.addUsers.firstName",
        },
        {
          key: "lastName",
          label: "modal.shareTo.addUsers.lastName",
        },
        {
          key: "mobilePhone",
          label: "modal.shareTo.addUsers.phone",
        },
        {
          key: "email",
          label: "modal.shareTo.addUsers.email",
        },
      ],
      queryGrid: {
        firstName: "",
        lastName: "",
      },
    };
  },
  computed: {
    dataSource() {
      return getUsers;
    },
  },
  methods: {
    getCondition() {
      return {
        ...this.queryGrid,
        sharedUserId: this.sharedUserId,
        searchId: this.searchId,
      };
    },
    onTotalChanged() {},
    onFieldsGet() {},
    getSelectItems() {
      return this.$refs.selectableTable.getSelectedItems();
    },
    refreshGrid() {
      return this.$refs.selectableTable.refresh();
    },
  },
};
</script>

<style>
.content-shareto > .center-bar:not(:first-child) {
  margin-top: 10px;
}
.content-shareto > .center-bar > .content-main > .content-party {
  margin-top: 10px;
}
</style>
